import React from "react";

// Reserve the same image square and content area as ProductCard, not a shorter tile.
export const ProductGridSkeleton = () => (
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6" data-testid="shop-loading" role="status" aria-label="Chargement des produits">
    {Array.from({ length: 8 }).map((_, i) => (
      <div className="product-card" key={i} aria-hidden="true" data-testid={`product-skeleton-${i}`}>
        <div className="product-image bg-night-2 animate-pulse" />
        <div className="p-4 flex flex-col gap-3 flex-1">
          <div className="h-[22.5px] bg-white/5 animate-pulse" />
          <div className="h-[39px] bg-white/5 animate-pulse" />
          <div className="h-[47px] mt-auto pt-3 border-t border-white/5" />
        </div>
      </div>
    ))}
  </div>
);